import ImageWithFallback from "./ImageWithFallback.jsx";
import { MapPin } from "lucide-react";

export default function ShopSelect({ shops, onSelect }) {
  return (
    <div className="space-y-4">
      {shops.map((shop) => (
        <div
          key={shop.id}
          onClick={() => onSelect(shop)}
          className="relative bg-card border border-border rounded-lg p-4 overflow-hidden group hover:border-gold/50 transition-all cursor-pointer active:scale-[0.98]"
        >
          {/* Decorative corner accents */}
          <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden pointer-events-none">
            <div className="absolute top-2 -right-8 w-24 h-[2px] bg-gold rotate-45 opacity-30" />
            <div className="absolute top-6 -right-8 w-24 h-[2px] bg-gold rotate-45 opacity-20" />
          </div>

          <div className="flex gap-4 items-center">
            {/* Shop Image */}
            <div className="w-28 h-28 flex-shrink-0 rounded-lg overflow-hidden border border-border">
              <ImageWithFallback
                src={shop.image_url}
                alt={shop.name ? `Foto do salao ${shop.name}` : "Foto do salao"}
                label={shop.name || "Salao"}
                variant="salon"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Shop Info */}
            <div className="flex-1 min-w-0">
              <h3 className="text-xl font-semibold text-white mb-2 truncate">
                {shop.name}
              </h3>

              {shop.address && (
                <div className="flex items-start gap-2 text-muted">
                  <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span className="text-sm line-clamp-2">{shop.address}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
